import { UploadOutlined } from "@ant-design/icons";
import { Button, message, Upload } from "antd";
import type { RcFile } from "antd/es/upload/interface";
import React from "react";

const UploadImage = ({ onFileUpload }: { onFileUpload: Function }) => {
  const beforeUpload = (file: RcFile) => {
    const isJpgOrPng = ["image/png", "image/jpg", "image/jpeg"].includes(
      file.type,
    );
    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG file!");
      return Upload.LIST_IGNORE;
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error("Image must smaller than 2MB!");
      return Upload.LIST_IGNORE;
    }
    onFileUpload(file);
    return false;
  };

  const onRemove = () => {
    onFileUpload(null);
  };

  return (
    <Upload
      accept=".png, .jpg, .jpeg"
      maxCount={1}
      beforeUpload={beforeUpload}
      onRemove={onRemove}
    >
      <Button icon={<UploadOutlined />}>Click to Upload</Button>
    </Upload>
  );
};

export default UploadImage;
